import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://hyroxninja.com";

const upsertMeta = (selector, create, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    create(el);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;
    const url = SITE + (pathname === "/" ? "/" : pathname.replace(/\/$/, ""));

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    upsertMeta('meta[name="robots"]', (el) => el.setAttribute("name", "robots"),
      noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    upsertMeta('meta[property="og:title"]', (el) => el.setAttribute("property", "og:title"), title);
    upsertMeta('meta[property="og:url"]', (el) => el.setAttribute("property", "og:url"), url);
    upsertMeta('meta[name="twitter:title"]', (el) => el.setAttribute("name", "twitter:title"), title);
    if (description) {
      upsertMeta('meta[name="description"]', (el) => el.setAttribute("name", "description"), description);
      upsertMeta('meta[property="og:description"]', (el) => el.setAttribute("property", "og:description"), description);
      upsertMeta('meta[name="twitter:description"]', (el) => el.setAttribute("name", "twitter:description"), description);
    }
  }, [title, description, noindex, pathname]);

  return null;
};
